const stripTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

const isLocalHost = (host: string): boolean =>
  host.includes("localhost") || host.startsWith("127.0.0.1");

export const getApiBaseUrl = (): string => {
  const envApiUrl = String(import.meta.env.VITE_API_URL || "").trim();
  if (envApiUrl) {
    return stripTrailingSlash(envApiUrl);
  }

  if (typeof window === "undefined") {
    return "http://localhost:3001/api";
  }

  const host = window.location.hostname.toLowerCase();
  if (isLocalHost(host)) {
    return "http://localhost:3001/api";
  }

  if (host === "muay-thai.app" || host === "www.muay-thai.app") {
    return "https://api.muay-thai.app/api";
  }

  if (host === "app.muay-thai.app") {
    return "https://api.muay-thai.app/api";
  }

  return `${stripTrailingSlash(window.location.origin)}/api`;
};
